export type { IconSvgElement } from '@hugeicons/react';
export { Icon, type IconProps } from './icon';
